export class PortfolioIdsState {
	public portfolioIds: Array<string> = [];
}
